import { VOICE_ATTENUATION } from "constants/constants";
import { playInRangeSound, playOutRangeSound } from "helpers/sounds";
import { forceHandleSpaceChanges } from "slices/spaceMediaSlice";
import { dragActive } from "./spaceDrag";
import { drawVisible, drawShout, drawWithinDistance } from "./spaceDraws";
import {
  audioClearRange,
  audioModulateRange,
  mediaRange,
  myLuid,
  people,
  videoClearRange,
} from "./spaceVars";

let media2Change = {};

export function calcAllD2M() {
  let myX = people[myLuid].x;
  let myY = people[myLuid].y;
  for (var luid in people) {
    if (luid !== myLuid) {
      let x = people[luid].x;
      let y = people[luid].y;
      let newd2me = calcOneD2M(myX, myY, x, y, luid);
      if (dragActive) {
        if (newd2me > mediaRange) drawWithinDistance(luid, false);
        else if (newd2me < mediaRange) drawWithinDistance(luid, true);
      }
    }
  }
  // handleAllMagnitudes();
}
export function calcOneD2M(myX, myY, x, y, luid) {
  people[luid].d2me = Math.sqrt(Math.pow(myX - x, 2) + Math.pow(myY - y, 2));
  return people[luid].d2me;
}
export function checkMedia2Change(luid) {
  media2Change[luid] = true;
}
export function deleteMedia2Change(luid) {
  delete media2Change[luid];
}
export function resetMedia2Change() {
  media2Change = {};
}

export function gatherAnyInRangeChanges() {
  if (!dragActive) {
    let inRangeArray = [];
    for (var luid in media2Change) {
      let changes = newMediaChanges(luid);
      if (changes) inRangeArray.push(changes);
    }
    media2Change = {};
    if (inRangeArray.length > 0) {
      inRangeArray.forEach((el) => {
        drawVisible(el.luid, people[el.luid].time);
        drawShout(el.luid, people[el.luid].shout);
        handleMediaMagnitude(
          el.luid,
          people[el.luid].d2me,
          people[el.luid].shout,
          people[el.luid].pinnedShare
        );
      });
      return inRangeArray;
    } else return null;
  } else return null;
}

export function newMediaChanges(luid) {
  // We know when they appear or disappear from the sidebar by looking at the time value.
  // It tells us what time they appeared on the sidebar, if null: they are not previously on
  // the sidebar
  // We only handle stopping or starting media if there is a change to the time value
  if (people[luid].time) {
    if (people[luid].d2me > mediaRange) {
      people[luid].inRange = false;

      if (!people[luid].shout && !people[luid].pinnedShare) {
        people[luid].time = null;
        playOutRangeSound();
      }
      return {
        luid: luid,
        inRange: people[luid].inRange,
        time: people[luid].time,
        shout: people[luid].shout,
        pinnedShare: people[luid].pinnedShare,
      };
    } else {
      people[luid].inRange = true;
      /// Still return value incase it was the shout that changed
      return {
        luid: luid,
        inRange: people[luid].inRange,
        time: people[luid].time, // keep same appearance time
        shout: people[luid].shout,
        pinnedShare: people[luid].pinnedShare,
      };
    }
  } else {
    if (
      people[luid].d2me < mediaRange ||
      people[luid].shout ||
      people[luid].pinnedShare
    ) {
      if (people[luid].d2me < mediaRange) people[luid].inRange = true;
      else people[luid].inRange = false;
      people[luid].time = Date.now();
      playInRangeSound();

      // make new inRange time so the latest people get stacked at the end of the array
      return {
        luid: luid,
        inRange: people[luid].inRange,
        time: people[luid].time,
        shout: people[luid].shout,
        pinnedShare: people[luid].pinnedShare,
      };
    } else {
      window.efs_debug && window.log("Still not in range", 1);
      // should only occur when local or remote people enter space
      return null;
    }
  }
}

export function resetAllMedia() {
  for (let luid in people) if (luid !== myLuid) checkMedia2Change(luid);

  forceHandleSpaceChanges();
}

export function handleMediaMagnitude(luid, d2me, shout, pinnedShare) {
  let elem = document.getElementById(`sideVideo${luid}`);
  let audio = document.getElementById(`remoteAudio${luid}`);
  if (elem) {
    if (shout || pinnedShare) elem.style.opacity = 1;
    else {
      if (d2me < videoClearRange) elem.style.opacity = 1;
      else if (d2me < mediaRange) elem.style.opacity = 0.5;
      else elem.style.opacity = 0;
    }
  }
  if (audio) {
    if (shout) audio.volume = 1;
    else {
      if (d2me < audioClearRange) audio.volume = 1;
      else if (d2me < mediaRange)
        audio.volume = Math.exp(
          -(VOICE_ATTENUATION * ((d2me - audioClearRange) / audioModulateRange))
        );
      else audio.volume = 0;
    }
  }
}
